const HAS_SEEN_WELCOME_KEY = 'hasSeenWelcome';

// Іздеу роботтары мен өнімділік тексерулері — басты бет SEO үшін өзгеріссіз қалу керек
export const isBot = () => (
    /bot|crawl|spider|slurp|facebookexternalhit|lighthouse|pagespeed/i.test(navigator.userAgent)
);

// Сайтқа алғаш кірген қонақ па: кіріп қойған қолданушы және робот емес,
// бұрын қарсы алу бетін көрмеген болса — шын
export const isFirstVisit = () => {
    try {
        if (localStorage.getItem(HAS_SEEN_WELCOME_KEY)) return false;
        if (localStorage.getItem('access_token')) return false;
        return !isBot();
    } catch (e) {
        return false;
    }
};

export const markWelcomeSeen = () => {
    try {
        localStorage.setItem(HAS_SEEN_WELCOME_KEY, '1');
    } catch (e) {}
};